export const TOASTER_REMOVE = 'ipfabric/Toaster/TOASTER_REMOVE';
export const TOASTER_HIDE = 'ipfabric/Toaster/TOASTER_HIDE';
export const TOASTER_REMOVE_ALL = 'ipfabric/Toaster/TOASTER_REMOVE_ALL';
export const TOASTER_ADD_SUCCESS = 'ipfabric/Toaster/TOASTER_ADD_SUCCESS';
export const TOASTER_ADD_INFO = 'ipfabric/Toaster/TOASTER_ADD_INFO';
export const TOASTER_ADD_WARNING = 'ipfabric/Toaster/TOASTER_ADD_WARNING';
export const TOASTER_ADD_DANGER = 'ipfabric/Toaster/TOASTER_ADD_DANGER';
export const TOASTER_READ = 'ipfabric/Toaster/TOASTER_READ';
export const OPEN_CHANGE = 'ipfabric/Toaster/OPEN_CHANGE';
